export namespace WallboardActions {
  export const COMPONENT_NAME = 'Wallboard';

  export class LoadBootstrap {
    public static readonly type = `[${COMPONENT_NAME}] Load Bootstrap`;
  }

  export class LoadContent {
    public static readonly type = `[${COMPONENT_NAME}] Load Content`;
  }

  export class Refresh {
    public static readonly type = `[${COMPONENT_NAME}] Refresh`;
  }
}
